export const transformProfitLossApiData = (apiData) => {
  if (!apiData?.columns || !apiData?.rows) {
    return { headers: [], rows: [] };
  }

  const rows = [];

  const processNode = (node, level = 0, parentId = null) => {
    const hasChildren = Array.isArray(node.children) && node.children.length > 0;
    const rowId = node.id || `row-${level}-${rows.length}`;

    let type = "data";
    if (node.id === "NET_PROFIT") type = "grand-total";
    else if (node.summary) type = "sub-total";
    else if (node.group) type = "level-0";
    else if (level === 1) type = "level-1";

    rows.push({
      id: rowId,
      parentId,
      type,
      level,
      hasChildren,
      label: node.label,
      values: [node.label, ...(node.values || [])],
      summaryValues: node.summary?.sub_totals,
    });

    node.children?.forEach((child) => processNode(child, level + 1, rowId));

    if (node.summary && node.id !== "NET_PROFIT") {
      rows.push({
        id: `${rowId}-summary`,
        parentId: rowId,
        type: "sub-total",
        level,
        hasChildren: false,
        label: node.summary.label,
        values: [node.summary.label, ...node.summary.sub_totals],
        summaryValues: node.summary.sub_totals,
      });
    }
  };

  apiData.rows.forEach((row) => processNode(row, 0));

  return {
    headers: ["ACCOUNT", ...apiData.columns.map((column) => column.label)],
    rows,
  };
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === "" || value === "-") {
    return "-";
  }

  if (typeof value === "string" && value.includes("%")) {
    return value;
  }

  const numericValue =
    typeof value === "number"
      ? value
      : parseFloat(String(value).replace(/,/g, ""));

  if (Number.isNaN(numericValue)) {
    return String(value);
  }

  return numericValue.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const isNegative = (value) => {
  if (value === null || value === undefined || value === "") return false;
  if (typeof value === "number") return value < 0;

  const numericValue = parseFloat(String(value).replace(/,/g, ""));
  return !Number.isNaN(numericValue) && numericValue < 0;
};
